import React, { useState } from 'react';
import { contactContent } from '../data/content';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    interest: '',
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    (async () => {
      setSubmitting(true);
      setStatusMessage('');
      try {
        // honeypot field
        const payload = { ...formData, phone: '' };

        // optionally get recaptcha token if site key provided and grecaptcha exists
        const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
        if (siteKey && window.grecaptcha && typeof window.grecaptcha.execute === 'function') {
          try {
            const token = await window.grecaptcha.execute(siteKey, { action: 'contact' });
            payload.recaptchaToken = token;
          } catch (err) {
            console.warn('recaptcha execute failed', err);
          }
        }

        const apiUrl = process.env.REACT_APP_CONTACT_API_URL || '/contact';
        const res = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const body = await res.json().catch(() => ({}));
          throw new Error(body.error || res.statusText || 'Request failed');
        }

        setFormData({ name: '', email: '', interest: '', message: '' });
        setStatusMessage('Thank you — your message has been sent.');
      } catch (err) {
        console.error('submit error', err);
        setStatusMessage('There was an error sending your message. Please try again later.');
      } finally {
        setSubmitting(false);
      }
    })();
  };

  return (
    <form onSubmit={handleSubmit} className="bg-stone-50 p-10">
      <div className="space-y-6">
        <div>
          <label htmlFor="name" className="form-label">
            Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="form-input"
            placeholder="Your name"
            required
          />
        </div>

        <div>
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="form-input"
            placeholder="your@email.com"
            required
          />
        </div>

        <div>
          <label htmlFor="interest" className="form-label">
            Area of Interest
          </label>
          <select
            id="interest"
            name="interest"
            value={formData.interest}
            onChange={handleChange}
            className="form-input"
            required
          >
            {contactContent.interestOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="message" className="form-label">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows={4}
            className="form-input resize-none"
            placeholder="Tell me about your goals..."
            required
          />
        </div>

        <button type="submit" className="w-full btn-primary mt-4">
          {submitting ? 'Sending…' : 'Send Message'}
        </button>
        {statusMessage && <p className="mt-3 font-body text-sm text-stone-600">{statusMessage}</p>}
      </div>
    </form>
  );
};

export default ContactForm;
